/**
 * Sağlayıcının (Google, Microsoft) onay ekranına gider: giriş ve takvim
 * bağlama. Web'de sayfa terk ediliyor, söz hiç çözülmüyor; dönüşü açılışta
 * `/baglanti/<sağlayıcı>` adresi işliyor (webAuth.ts, calendarAccounts.ts).
 *
 * Mobilde (mobile/src/shims/providerRedirect.ts) ekran telefonun tarayıcısında
 * açılıyor ve dönüş App Link ile uygulamaya geliyor; kullanıcı dönmeden
 * tarayıcıyı kapatırsa söz çözülüyor, akış tamamlanmamış sayılıyor.
 */
export function goToProvider(url: string): Promise<void> {
  window.location.assign(url);
  return new Promise<void>(() => {});
}
